"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "AnalyticsLogoCircle___StyledSvg",
  componentId: "sc-1lt6gm4-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function AnalyticsLogoCircle(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M185.737 297.909h77.556l-22.869-21.212zM194.354 230.958l-68.939 66.951 99.1-37.121zM159.222 197.151l-33.807 70.928 53.03-51.373zM284.506 237.919l-26.515-67.283-47.728 46.07 35.464 35.465zM328.919 243.222l-17.898 6.96 19.555 47.727h33.475z"
  }), _react["default"].createElement("path", {
    d: "M240.093 30.438c-115.341 0-209.47 94.46-209.47 209.47 0 115.009 94.129 209.469 209.47 209.469 115.34 0 209.47-94.129 209.47-209.47 0-115.34-94.46-209.47-209.47-209.47zM77.688 319.12l75.9-155.445 40.766 38.779 70.597-70.597 38.778 97.112 33.476-12.263L403.16 319.12H77.687z"
  }), _react["default"].createElement("path", {
    d: "M263.294 268.08l30.161 29.829h14.252l-15.91-40.435z"
  })));
}

var _default = AnalyticsLogoCircle;
exports["default"] = _default;